<template>
    <div class="message-alert-wrapper flex-center">
        <div class="content">
            <img src="@/assets/images/close.png" class="close" @click="close" alt="">
            <div class="left">
                <img src="@/assets/images/sm-logo.png" class="logo" alt="">
                <div class="title flex-start">
                    <div class="logo-wrapper">
                        <img src="@/assets/images/small-logo.png" alt="">
                    </div>
                    <p> 開店有疑難？</p>
                    <p class="sm">揾<span>專家</span>傾傾</p>
                </div>
                <div class="tips">有任何關於開網店或電商難題，不妨預約傾傾， LOOPSHOP 電商顧問會為你提供最適切的幫助。</div>
            </div>
            <div class="right">
                <img src="@/assets/images/pexels-george-milton.png" alt="">
            </div>
            <router-link to="/consultation">
                <div class="button-box">
                    <div class="items">預約免費開店諮詢</div>
                </div>
            </router-link>

        </div>
    </div>
</template>
<script>
export default {
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>
<style lang="scss" scoped>
.message-alert-wrapper {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .content {
        width: 7rem;
        border-radius: 0.16rem;
        background: #FFF;
        padding: 0.4rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        position: relative;

        .close {
            position: absolute;
            width: 0.24rem;
            height: 0.24rem;
            top: 0.12rem;
            right: 0.12rem;
            cursor: pointer;
        }

        .button-box {
            width: 100%;
            line-height: 0.3;

            .items {
                display: inline-block;
                padding: 0.16rem 0.8rem;
                border-radius: 0.08rem;
                background: var(--red-100, #E02E43);
                text-align: center;
                font-size: 0.24rem;
                font-family: PingFang HK;
                font-style: normal;
                font-weight: 600;
                line-height: 0.24rem;
                color: #ffffff;
                cursor: pointer;

            }
        }

        .left {
            position: relative;
            line-height: 1;
            flex: 1;

            .logo {
                width: 0.69rem;
                height: 0.32rem;
                flex-shrink: 0;
                display: block;
            }

            .tips {
                color: var(--black-100, #000);
                font-family: PingFang HK;
                font-size: 0.12rem;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                padding: 0 0.2rem 0 0.3rem;
            }

            .title {
                margin-top: 0.5rem;
                padding: 0 0 0 0.3rem;
                position: relative;
                color: var(--black-100, #000);
                font-family: PingFang HK;
                font-size: 0.4rem;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                display: flex;
                flex-wrap: wrap;

                p {
                    width: 100%;
                }

                span {
                    color: var(--red-100, #E02E43);
                }

                .logo-wrapper {
                    position: absolute;
                    top: -0.3rem;
                    left: -0.04rem;
                    width: 0.78rem;
                    height: 0.49rem;

                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }


            }
        }

        .right {
            width: 3.37147rem;
            height: 2.82562rem;
            border-radius: 0.06rem;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
    }
}

@media (max-width: 750px) {


    .message-alert-wrapper .content {
        display: block;
    }

    .message-alert-wrapper .content .left .logo {
        width: 1rem;
        height: auto;
    }

    .message-alert-wrapper .content .left .title p {
        text-align: center;
    }

    .message-alert-wrapper .content .left .title .sm {
        transform: translateX(-0.2rem);
    }

    .message-alert-wrapper .content .left .title .logo-wrapper {
        position: absolute;
        top: -0.3rem;
        left: 1.6rem;
        width: 0.78rem;
        height: 0.49rem;
    }

    .message-alert-wrapper .content .left .tips {
        font-size: 0.14rem;
    }

}
</style>